import { Skeleton, styled, useMediaQuery, useTheme } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

const LoaderContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  rowGap: '15px',
  [theme.breakpoints.up('md')]: {},
}));

interface PackageLoaderProps {
  skeletonItemsPackage?: number;
  width?: string;
  height?: number;
}

const ItemLoader = styled(Skeleton)({
  transform: 'scale(1)',
});

const PackageLoader: FC<PackageLoaderProps> = ({ skeletonItemsPackage = 1, height, width }) => (
  <>
    {Array.from({ length: skeletonItemsPackage })
      .fill(1)
      .map((_, index) => (
        <ItemLoader
          // eslint-disable-next-line react/no-array-index-key -- Items always look exactly the same, so it's safe to use index here.
          key={index}
          width={width}
          height={height}
        />
      ))}
  </>
);

export const PackagesLoader = () => {
  const { getTestIdProps } = useTestId();
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));

  return (
    <LoaderContainer {...getTestIdProps('packages-loader')}>
      <Skeleton
        height={26}
        width={72}
      />
      <PackageLoader
        width={isMobile ? '100%' : '372px'}
        height={60}
      />
    </LoaderContainer>
  );
};
